import './App.css';
import { Component } from 'react';
import './font/RussoOne-Regular.ttf';

class App extends Component {
  constructor(props) {
    super(props);
    this.state= {
      isOn: false,
      isCheck: false,
      car: "volvo"
    }
  }

  handleClick() {
    this.setState( state => ({
      isOn: !state.isOn
    }))
  }

  changeCheck() {
    this.setState( state => ({
      isCheck: !state.isCheck
    }))
  }

  changeCar(value) {
    this.setState( state => ({
      car: value
    }))
  }

  render() {
    document.body.style.backgroundImage = "url(images/back.png)";
    document.body.style.backgroundSize = "cover";
    document.body.style.backgroundPosition = "center";
    document.body.style.backgroundAttachment = "fixed";

    return (
      <div className="App">
        <p>
          <img src="images/logo.png" alt="logo..." className="App-image"></img>
        </p>
        <p>
          <div className="mainDesc">
          Explore a mysterious non-linear world filled with puzzles and secrets. Make small creatures work together to lift the curse and reconnect the world. 
          </div>
        </p>
        
        <p className="ytVideo">
          <div className="container">
            <iframe title="youtubeVid" className="media" width="960" height="540" src="https://www.youtube.com/embed/cEmPinhne6E?si=EGfBIF7iesTihKAX" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
        </p>
        <p>
          <div className="mainDesc">
          Ligo is an exploration Sokoban game, where you solve handcrafted puzzles and mysteries about the world by merging, cutting, pushing smalls creatures together and destroying squids with blocks. 
          </div>
        </p>
        <p>
          <div className="container">
          <video className="media" width="560" height="425" muted autoPlay={"autoplay"} preLoad="auto" loop>
            <source src="images/puzzle-1.mp4" type="video/mp4"></source>
            Your browser does not support the video tag.
          </video>
          </div>
        </p>
        <p>
          <div className="mainDesc">
          Each part of the world has different rules and challenges. Each puzzle contains a new idea, a new challenge.
          </div>
        </p>
        <p>
          <div className="container">
          <video className="media" width="560" height="425" muted autoPlay={"autoplay"} preLoad="auto" loop>
            <source src="images/puzzle-2.mp4" type="video/mp4"></source>
            Your browser does not support the video tag.
          </video>
          </div>
        </p>
        <p>
          <div className="mainDesc">
          Unravel the puzzles, start your Ligo journey!
          </div>
          <div className="mainDesc">
          Available Now
          </div>
        </p>
        <p className="ytVideo">
          <iframe title="steamLink" className="media" src="https://store.steampowered.com/widget/2462810/" frameborder="0" width="646" height="190"></iframe>
        </p>
        <p>
          <iframe title="itchioLink" className="itchio" frameborder="0" src="https://itch.io/embed/2324241?bg_color=1e2139&amp;fg_color=ffffff&amp;link_color=578d32&amp;border_color=485177" width="552" height="167"><a href="https://aberleur.itch.io/ligo-demo">Ligo demo by Anthony Berleur</a></iframe>
        </p>
        <p>
          <div className="title">
            Created by  <a className="nameLink" href="https://x.com/AnthonyBerleur">Anthony Berleur</a> 
          </div>
          <div className="title">
            Visual design by  <a className="nameLink" href="https://alexruso.myportfolio.com/">Alex Russo</a> 
          </div>

          <div className="title">
            Sound design and music by  <a className="nameLink" href="https://www.abrasounds.com/">Gustavo Coutinho</a> 
          </div>
        </p>
        <p className="presskit">
          <a class="button button-primary" href="mailto:anthonyberleurgames@gmail.com">Contact</a>
          <a class="button button-primary" href="/press/">Press kit</a>
        </p>
      </div>
    );
  }
}

export default App;
